import { ARABIC_SYMBOLS } from '@constants/currency';

import { Currency } from '@wegoTypes/currency';

export const getCurrencySymbolFontFamily = (currencyCode: string) => {
  return ['AED', 'SAR'].includes(currencyCode) ? 'custom-currency-symbols' : undefined;
};

export const checkIsSymbolFontLoaded = (currencyCode: string): boolean => {
  const symbolFontFamily = getCurrencySymbolFontFamily(currencyCode);

  return symbolFontFamily ? document.fonts.check(`1em ${symbolFontFamily}`) : true;
};

export const getCurrencySymbol = (currency: Currency) => {
  const symbolFontFamily = getCurrencySymbolFontFamily(currency.code);

  if (symbolFontFamily && checkIsSymbolFontLoaded(currency.code)) {
    return ARABIC_SYMBOLS[currency.code] + ' ';
  }

  return currency.symbol;
};
